module.exports = __webpack_public_path__ + "static/media/Folder view and list view of the Document section.86bbd927.png";